export const SET_SCHEDULES_LOADED = "SET_SCHEDULES_LOADED";

export const setSchedulesLoaded = (schedulesLoaded: boolean) => {
    return {
        schedulesLoaded,
        type: SET_SCHEDULES_LOADED
    };
};
